

// object to store loaded CSS chunks
var installedCssChunks = {
	179: 0
}
__webpack_require__.f.compat = (chunkId, promises) => {


	// mini-css-extract-plugin CSS loading
	var cssChunks = {"553":1,"943":1};
	if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
	else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
		promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
			var href = "" + chunkId + ".css";
			var fullhref = __webpack_require__.p + href;
			var existingLinkTags = document.getElementsByTagName("link");
			for(var i = 0; i < existingLinkTags.length; i++) {
				var tag = existingLinkTags[i];
				var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
				if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
			}
			var existingStyleTags = document.getElementsByTagName("style");
			for(var i = 0; i < existingStyleTags.length; i++) {
				var tag = existingStyleTags[i];
				var dataHref = tag.getAttribute("data-href");
				if(dataHref === href || dataHref === fullhref) return resolve();
			}
			var linkTag = document.createElement("link");
			linkTag.rel = "stylesheet";
			linkTag.type = "text/css";
			linkTag.onload = resolve;
			linkTag.onerror = function(event) {
				var request = event && event.target && event.target.src || fullhref;
				var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
				err.code = "CSS_CHUNK_LOAD_FAILED";
				err.request = request;
				delete installedCssChunks[chunkId]
				linkTag.parentNode.removeChild(linkTag)
				reject(err);
			};
			linkTag.href = fullhref;

			var head = document.getElementsByTagName("head")[0];
			head.appendChild(linkTag);
		}).then(function() {
			installedCssChunks[chunkId] = 0;
		}));
	}
};